import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidPlaneDepartureIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.2 3.8c-.8-.8-2.2-.8-3 0L14 7.1 7.5 4.9c-.4-.1-.8 0-1 .2l-.9.9c-.4.4-.4 1 0 1.4.1.1.2.2.3.2L11 10l-3.6 3.6c-.3.3-.8.4-1.2.2l-1.1-.5c-.4-.2-.8-.1-1.2.2l-.4.5c-.4.4-.4 1 0 1.4l5.1 5.1c.4.4 1 .4 1.4 0l.6-.6c.3-.3.4-.8.2-1.2l-.5-1.1c-.2-.4-.1-.8.2-1.2L14 13l2.4 5.2c.2.5.8.7 1.3.5.1 0 .2-.1.3-.2l.9-.9c.3-.3.4-.7.2-1L16.9 10l3.2-3.2c.9-.8.9-2.2.1-3Z"/>
  </SvgIcon>
}

export default SolidPlaneDepartureIcon
